import { render, staticRenderFns } from "./PromotionInfo.vue?vue&type=template&id=51fe75e4&scoped=true"
import script from "./PromotionInfo.vue?vue&type=script&lang=js"
export * from "./PromotionInfo.vue?vue&type=script&lang=js"
import style0 from "./PromotionInfo.vue?vue&type=style&index=0&id=51fe75e4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fe75e4",
  null
  
)

export default component.exports